import {Component, OnInit, ElementRef, ViewChild} from '@angular/core';
import {FormGroup, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import {Consultant} from '../../../models/Consultant.model';
import {ConsultantService} from '../../../services/consultant.service';
import {CnaeService} from '../../../services/cnae.service';
import { AwsService } from '../../../services/aws.service';
import {CommonHelper} from '../../../shared/helpers/CommonHelper';
import {UserService} from '../../../services/user.service';
import { BankService } from '../../../services/bank.service';
import {Responsible} from '../../../models/Responsible.model';
import {ContractType} from '../../../shared/enums/ContractType';
import {ActivatedRoute, Router} from '@angular/router';
import {HonorariumType} from '../../../shared/enums/HonorariumType';
import {ToastsManager} from 'ng2-toastr';
import {ConsultantSearch} from "../../../models/ConsultantSearch.model";
import { PixKeyType } from '../../../shared/enums/PixKeyType';

import { CompanyService } from '../../../services/billing-letter/company.service';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { SapItemType } from '../../../shared/enums/SapItemType';

import * as _ from 'lodash';
import { CompaniesService } from '../../../services/companies.service';
import { PixValidation } from '../../../shared/helpers/PixValidation';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { kenobyConsultantService } from '../../../services/kenobyConsultants.service';
import { GUARDS } from '../../../shared/auth/Roles';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { BorrowedNote } from '../../../models/BorrowedNote.model';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { ExcellenceCenter } from "../../../models/ExcellenceCenter.model";
import { PublicConsultantService } from "../../../services/public-consultant.service";

@Component({
    selector: 'app-consultant-create',
    templateUrl: './consultant-create.component.html',
    styleUrls: ['./consultant-create.component.css']
})
export class ConsultantCreateComponent implements OnInit {
    @ViewChild('uploadInput') uploadInput:ElementRef;
    @ViewChild("buttonOpenModalBorrowNote") buttonOpenModalBorrowNote: ElementRef;
    @ViewChild("buttonOpenModalPreview") buttonOpenModalPreview: ElementRef;
    emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    emailPatternFC = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    cpfPattern = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2})$/i;
    consultantForm: FormGroup;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
    accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
    agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
    digitMask = [/[A-Za-z0-9]/];
    bankCodeMask = [/[0-9]/,/[0-9]/,/[0-9]/];
    phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] ;
    consultantSearch = new ConsultantSearch();
    consultant: Consultant = new Consultant();
    commonHelper: CommonHelper = new CommonHelper();
    responsibles: Responsible[] = new Array<Responsible>();
    bps: Responsible[] = new Array<Responsible>();
    options: any;
    honorarium: Boolean;
    showSoldHoursValue: Boolean;
    showHourValue: boolean = false;
    showTotalValue: boolean = false;
    showHourValueBenefits: boolean = false;
    showMensalHours: boolean = false;
    disableHourValue: boolean = false;
    errors = [];
    selectedFiles:FileList;
    chequePayment = true;
    customers: any = [];
    skills: any = [];
    skillsDropdown = { list: [], options: null, selected: [] };
    projectsAll: any = [];
    projectsDropdown = { list: [], options: null, selected: [] };
    loading;
    cnaes = [];
    occupations = [];
    skillAux: string = '';
    banks : any = [];
    pixKeyVerifyMethod : any;
    pixKeyFlag: Boolean = true;
    pixCpfValid : Boolean;
    pixCnpjValid : Boolean;
    phoneMaskFlag: Boolean = false;
    bankForEdit: any = [];
    bankCode: number;
    bankName: string;
    bankCountry: string;
    textMask;
    contractDataInvalid: Boolean;
    personalDataInvalid: Boolean;
    isKenobyOrigin: Boolean = false;
    kenobyConsultantId: string = '';
    user;
    GUARDS = GUARDS;
    reloadDocModal: boolean = false;
    typeContractModal: string = '';
    typeAdtiveModal: number;

    borrowNoteStarted: Boolean = false;
    consultantsBorrowInvoice: Consultant[] = [];
    excellenceCenters: Array<ExcellenceCenter> = [];
    supportCenters: Array<ExcellenceCenter> = [];
    allCenters: Array<ExcellenceCenter> = [];
    hasRequiredExcellenceCenter: boolean = false;

    constructor(public consultantService: ConsultantService,
                private userService: UserService,
                private awsService: AwsService,
                private router: Router,
                private route: ActivatedRoute,
                private formBuilder: FormBuilder,
                private toastr: ToastsManager,
                private companyService: CompanyService,
                private companiesService: CompaniesService,
                private dropDownItemFactory: DropdownItemFactory,
                private dropDownSettingFactory: DropdownSettingsFactory,
                private cnaeService: CnaeService,
                private bankService: BankService,
                private projectFinancialService: ProjectFinancialService,
                private kenobyConsultantService: kenobyConsultantService,
                public pixValidation: PixValidation,
                private errorHandler: ErrorHandlerProvider,
                private localStorage: LocalStorage,
                private excellenceCentersService: ExcellenceCentersService,
                private publicConsultantService: PublicConsultantService
        ) {
    }

    async ngOnInit() {
        this.loading = true;
        this.user = this.localStorage.retrieve('user');
        this.textMask = {mask: false}
        this.options = this.commonHelper.getDatePickerOptions();
        this.consultantForm = this.formBuilder.group({
            name: [null, Validators.required],
            begin:[null, Validators.required],
            email: [null, [Validators.required, Validators.email]],
            fcEmail: [null, [Validators.required, Validators.email]],
            contractKind: [null, [this.validateSelectOption]],
            rg: [null, [Validators.required]],
            cpf: [null, [Validators.required, Validators.pattern(this.cpfPattern)]],
            sex: [null, [this.validateSelectOption]],
            civilStatus: [null, [this.validateSelectOption]],
            cep: [null, null],
            address: [null,null],
            number: [null, null],
            district: [null, null],
            city: [null, null],
            country: [null, null],
            state: [null,null],
            responsible: [null, [this.validateSelectOptionResponsible]],
            bp: [null, [this.validateSelectOptionBP]],
            bank: [null, [this.validateSelectOptionBank]],
            pixType: [null, null],
            keyPix:[null,[this.validateKeyPix]],
            agency: [null, Validators.required],
            account: [null, Validators.required],
            digit: [null, Validators.required],
            born: [null, Validators.required],
            consultantStart: [null, Validators.required],
            cellPhone: [null, Validators.maxLength(20)],
            position: [null, null],
            excellenceCenter: [null, [this.validateSelectOptionExcellenceCenter]],
            supportCenter: [null, null]
        });

        this.customers = await this.companyService.getAll();
        this.customers = _.orderBy(this.customers,[company => company.name.toUpperCase()]);

        this.skills = await this.consultantService.getAllSkills();
        this.skillsDropdown.options = this.dropDownSettingFactory.build({text:'Skills'});
        this.skillsDropdown.list = this.dropDownItemFactory.build({source:this.skills});

        this.projectsDropdown.options = this.dropDownSettingFactory.build({text: 'Projects'});

        this.responsibles = await this.userService.getActiveUsers();
        this.bps = [...this.responsibles];
        this.cnaes = await this.cnaeService.getAllItems([SapItemType.CnaeConsultant]);
        this.occupations = await this.consultantService.getAllContractProfile();
        this.banks = await this.bankService.getBanks();
        this.consultant.payment.typePix = 0;
        this.consultantForm.get("keyPix").disable();
        this.consultantForm.get("fcEmail").disable();

        if (!_.isEmpty(this.route.snapshot.queryParams)) {
            const isKenoby = this.route.snapshot.queryParams["kenoby"];
            if (isKenoby == 'true') {
                const id = this.route.snapshot.queryParams["id"];
                if (id) {
                    this.isKenobyOrigin = true;
                    this.kenobyConsultantId = id;
                    await this.loadKenobyData(id);
                };
            };
        };
        this.allCenters = await this.excellenceCentersService.getAll();

        this.excellenceCenters = this.allCenters.filter(center => center.type == 1 );
        this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

        this.supportCenters = this.allCenters.filter(center => center.type == 2 );
        this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);

        this.loading = false;
    }

    async loadKenobyData(id) {
      const consultant = await this.kenobyConsultantService.getConsultantKenoby(id);
      const formFields = [
        "name",
        "email",
        "city",
        "state",
        "sex",
        "cellPhone",
        "born",
        "position"
      ];

      const consultantFields = [
        "name",
        "email",
        "city",
        "state",
        "gender",
        "cellPhone",
        "born",
        "position"
      ];

      formFields.forEach((fieldName, index) => {
        const field = this.consultantForm.get(fieldName);
        if(field !== null) {
            const value = consultant[consultantFields[index]];
            field.setValue(value);
        }
      });

      if(consultant.skills && consultant.skills.length > 0) {
        let skills = [];
        consultant.skills.map(s => s.name).forEach(skillKenoby => {
            const skillsExists = this.skills.find(s => s.name.toLowerCase() === skillKenoby.toLowerCase());
            if(skillsExists)
                skills.push({ id: skillsExists._id, itemName: skillsExists.name });
        });
        this.skillsDropdown.selected = [...skills];
      }

/*       const setDropDownInitialState = undefined;
      this.consultant.subDivision = setDropDownInitialState; */
    }

    validateSelectOptionResponsible(control: AbstractControl) {
        if (control.value === '' || control.value == 'undefined')
            return {responsible: true};

        return null;
    }

    validateSelectOptionBP(control: AbstractControl) {
        if (control.value === '' || control.value == 'undefined')
            return {bp: true};

        return null;
    }

    validateSelectOptionBank(control: AbstractControl) {
        if (control.value === '0' || !control.value)
            return {bank: true};

        return null;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0)
            return {contractKind: true};

        return null;
    }

    validateSelectOptionExcellenceCenter(control: AbstractControl) {
        if (control.value === '' || control.value == 'undefined')
            return {excellenceCenter: true};

        return null;
    }

    validateSelectOptionSupportCenter(control: AbstractControl) {
        if (control.value === '' || control.value == 'undefined')
            return {supportCenter: true};

        return null;
    }

    trim(){
        if(this.consultant.email)
            this.consultant.email = this.consultant.email.trim();
        if(this.consultant.fcEmail)
            this.consultant.fcEmail = this.consultant.fcEmail.trim();
        if(this.consultant.name)
            this.consultant.name = this.consultant.name.trim();
        if(this.consultant.payment.keyPix)
            this.consultant.payment.keyPix = this.consultant.payment.keyPix.trim();
    }

    clear(){
        this.consultant = new Consultant();
        this.errors = [];
        this.uploadInput.nativeElement.value = '';
        this.skillsDropdown.selected = [];
        this.projectsDropdown.selected = [];
    }

    async create() {
        this.consultantForm["submited"] = true;
        if (this.consultantForm.valid == false) {
            let errors = [];
            Object.keys(this.consultantForm.controls).forEach(control => {
                const controlErrors = this.consultantForm.get(control).errors
                if(controlErrors != null){
                    Object.keys(controlErrors).forEach(error =>{
                        let field = this.getVerboseField(control);
                        if(error == 'email'){
                            errors.push(`${field.verbose}: Formato de e-mail inválido`)
                        }

                        if(
                            error == 'required' ||
                            error == 'responsible' ||
                            error == 'bp' ||
                            error == 'excellenceCenter' ||
                            error == 'keyPix' ||
                            error == 'bank' ||
                            error == 'contractKind' ||
                            error == 'supportCenter'
                        ) {
                            errors.push(`Preencha o campo ${field.verbose}`)
                        }

                        if(error == 'maxlength'){
                            errors.push(`O campo ${field.verbose} ultrapassa o limite de caracteres`)
                        }

                    });
                }
            });
            this.errors = errors;
            return;
        }


        this.consultant.responsible.name = this.responsibles.find(x => x._id === this.consultant.responsible._id).name;
        this.consultant.responsible.username = this.responsibles.find(x => x._id === this.consultant.responsible._id).username;
        this.consultant.bp.name = this.bps.find(x => x._id === this.consultant.bp._id).name;
        this.consultant.fcEmail = this.consultant.fcEmail.toLowerCase();
        this.consultant.email = this.consultant.email.toLowerCase();
        this.consultant.name = this.consultant.name.trim();
        this.consultant.excellenceCenter = this.excellenceCenters.find(ec => ec._id == this.consultant.excellenceCenter._id);
        this.consultant.supportCenter = this.supportCenters.find(cs => cs._id == this.consultant.supportCenter._id) || {} as ExcellenceCenter;

        // previne que o consultor seja definido como responsável por ele mesmo
        if (this.consultant.fcEmail === this.consultant.responsible.username) {
            let errors = [];
            errors.push("O consultor não pode ser definido como seu próprio responsável. Selecione outro responsável.")
            this.errors = errors;
            return this.toastr.warning("O consultor não pode ser definido como seu próprio responsável. Selecione outro responsável.");;
        }

        if(this.consultant.contract.customers.some(c => !c._id || !c.start))
            return this.toastr.warning('Há campos obrigatórios na sessão Clientes que não foram preenchidos', 'Erro no módulo Consultor');

        this.consultant.contract.customers = this.consultant.contract.customers.map(c => {
            const customer = this.customers.find(x => x._id === c._id);
            c.name = customer.name;
            return c;
        });

        try {
            this.loading = true;
            let response = await this.consultantService.create(this.consultant);
            if(response._id){

                if(this.isKenobyOrigin && this.kenobyConsultantId)
                    await this.kenobyConsultantService.updateConsultantKenoby(this.kenobyConsultantId, { status: 2 });

                this.toastr.success("Consultor cadastrado com sucesso!");

                await this.addConsultantProject(this.projectsDropdown.selected, response);

                this.loading = false;

                if(this.selectedFiles)
                    this.upload(response._id);
                this.clear();
            } else {
                this.loading = false;
                this.errorHandler.interceptError(response, 'Consultor');
            }
        } catch (err) {
            this.loading = false;
            this.router.navigate(['/consultants']);
            this.errorHandler.interceptError(err, 'Consultor');
        }

    }

    verifyValidTouched(fieldName) {
        let field = this.consultantForm.get(fieldName);
        return ((!field.valid && field.touched) || (!field.valid && this.consultantForm["submited"]));
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    changedContractType() {

        this.consultant.contract.mensalHours = 0;
        this.consultant.contract.soldHourValue = 0;
        this.consultant.contract.hourValue = 0;
        this.consultant.contract.hourValueBenefits = 0;
        this.consultant.contract.totalValue = 0;
        this.consultant.contract.totalCostWithBenefits = 0;

        this.consultant.contract.honorarium = 0;

        let kind = this.consultant.contract.kind;


        if (kind === ContractType.CLT) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.showTotalValue = true;
            this.showHourValueBenefits = true;
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showSoldHoursValue = true;
            this.consultantForm.get('position').setValidators(null);
        }

        if (kind === ContractType.Intern || kind === ContractType.Others) {
            this.showTotalValue = true;
            this.showMensalHours = true;
            this.showHourValueBenefits = false;
            this.showHourValue = true;
            this.disableHourValue = false;
            this.consultantForm.get('position').setValidators(null);
        }

        if (kind === ContractType.PJ) {
            this.showTotalValue = false;
            this.showHourValue = false;
            this.showHourValueBenefits = false;
            this.showMensalHours = false;
            this.disableHourValue = false;
            this.consultantForm.get('position').setValidators([this.validateSelectOption]);
        }

        this.consultantForm.get('position').updateValueAndValidity({onlySelf: false, emitEvent: false});
    }

    changedHonorarium() {
        let honor = this.consultant.contract.honorarium;
        this.honorarium = true;
        this.showSoldHoursValue = true;

        if (honor === HonorariumType.OpenHour) {
            this.showTotalValue = false;
            this.showHourValue = true;
            this.showHourValueBenefits = false;
            this.showMensalHours = false;
            this.disableHourValue = false;
        }

        if (honor === HonorariumType.ClosedHour) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.consultant.contract.hourValueBenefits = this.consultantService.calculateHourValue(this.consultant);
            this.showTotalValue = true;
            this.showHourValue = true;
            this.showHourValueBenefits = false;
            this.disableHourValue = true;
            this.showMensalHours = true;
        }
    }

    getVerboseField(name){
        return _.find(this.commonHelper.getConsultantVerboseFields(),{name:name});
    }


    calculateHourValue() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.ClosedHour)) {
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    calculateHourValueBenefits() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.ClosedHour)) {
            this.consultant.contract.hourValueBenefits = this.consultantService.calculateHourValueBenefits(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    async verifyEmail(){
        this.trim();
        if(!this.consultant.fcEmail)
            return this.toastr.warning("E-mail Nação Digital é obrigatório.");
        if(!this.consultant.personal.cpf)
            return this.toastr.warning("CPF é obrigatório");

        const response = await this.publicConsultantService.verifyIfEmailExists(this.consultant.fcEmail);
        if(response.error) {
            this.toastr.error(response.error.message);
            this.consultant.fcEmail = "";
        } else if(response.emailExists) {
            this.toastr.warning(`E-mail FC ${this.consultant.fcEmail} já está em uso!`);
            this.consultant.fcEmail = "";
        }
    }

    async verifyCPF(){
        const clearCpf = () => {
            this.consultant.personal.cpf = "";
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
        }

        try {
            const cpf = this.consultant.personal.cpf;
            if(cpf == null || cpf == ""){
                clearCpf();
                return this.toastr.warning("O CPF é obrigatório!");
            }

            if(!(this.commonHelper.cpfValidator(cpf))){
                clearCpf();
                return this.toastr.warning("CPF inválido");
            }

            let responseCpfExists = await this.consultantService.verifyCPF(this.consultant);
            if(responseCpfExists.length > 0){
                clearCpf();
                return this.toastr.warning(`Este CPF é utilizado pelo consultor: ${responseCpfExists[0].name}`,"CPF já está em uso!");
            }

            let responseFreshService = await this.consultantService.getFreshServiceEmailByCPF(cpf);
            if(responseFreshService && responseFreshService.fcEmail) {
                this.consultant.fcEmail = responseFreshService.fcEmail;
                this.consultant.freshServiceId = responseFreshService.freshServiceId;
                this.verifyEmail();
            } else {
                this.errorHandler.interceptError(responseFreshService, 'Consultor');
            }
            this.disableFcEmail();
        } catch(err) {
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    disableFcEmail(){
        const control = this.consultantForm.get('fcEmail');
        if(!this.consultant.personal.cpf)
            control.disable();
        else
            control.enable();
    }

    async verifyCPFCNPJPixKey(){
        if(this.consultant.payment.keyPix == null || this.consultant.payment.keyPix == ""){
            this.toastr.warning("O CPF/CNPJ é obrigatório!");
            this.consultant.payment.keyPix = "";
        } else if(this.commonHelper.cpfValidator(this.consultant.payment.keyPix)){
            this.pixCpfValid = true;
        } else if(this.companiesService.cnpjValid(this.consultant.payment.keyPix)){
          this.pixCnpjValid = true;
        }else if(!this.pixCnpjValid && !this.pixCpfValid){
          this.toastr.warning('CPF/CNPJ inválido.');
          this.consultant.payment.keyPix = "";
        }
    }

    cnpjValid(cnpj: String) {
        return this.consultantService.cnpjValid(cnpj);
    }

    async getCnpj(cnpj: String) {
        return await this.consultantService.getCnpj(cnpj);
    }

    randomPixKeySearch(){
        if(this.consultant.payment.keyPix == '' || this.consultant.payment.keyPix == undefined) {
            this.toastr.warning('Aleatório não pode ser vazio');
        } else if (!this.consultantService.randomPixKeyValid(this.consultant.payment.keyPix)) {
            this.toastr.warning('Aleatório inválido. Aleatório deve ter 36 caracteres!');
            this.consultant.payment.keyPix = ''
        }
    }

    async verifyEmailPixKey(){
        this.trim();

        if(this.consultant.payment.keyPix == null || this.consultant.payment.keyPix == ""){
         this.toastr.warning("O Email é obrigatório!");
         this.consultant.fcEmail = "";
        }else{
            if (!(new RegExp(this.emailPattern).test((this.consultant.payment.keyPix).toString()))) {
                this.toastr.warning(`Digite um email válido.`, "Email inválido!");
                this.consultant.payment.keyPix = "";
            }
        }


    }

    async cepSearch(){
        let cep = this.consultant.personal.cep;
        cep = cep.replace(/\-/g, "");
        if(cep == '' || cep.length != 8){
            this.toastr.warning('CEP inválido');
        } else {
            this.toastr.warning('Realizando consulta ao CEP...');
            let response = await this.consultantService.getCep(cep);
            this.consultant.personal.address = response.logradouro;
            this.consultant.personal.district = response.bairro;
            this.consultant.personal.city = response.localidade;
            this.consultant.personal.state = response.uf;
        }
    }

    async cnpjSearch(){
        try {
            let cnpj = this.consultant.contract.cnpj;
            if(cnpj == '')
                return this.toastr.warning('CNPJ não pode ser vazio!');
            if(!this.consultantService.cnpjValid(cnpj))
                return this.toastr.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');

            this.toastr.warning('Realizando consulta ao CNPJ...');
            cnpj = cnpj.trim();

            let response = await this.consultantService.getCnpj(cnpj, true);
            if(response.success) {
                if(response.isMei) {
                    this.consultant.contract.cnpj = '';
                    this.consultant.contract.companyName = '';
                    return this.toastr.warning(`O CNPJ ${cnpj} é do tipo MEI e não pode ser utilizado no sistema`, 'CNPJ Bloqueado');
                }

                this.consultant.contract.companyName = response.nome;
                this.consultant.contract.address = response.logradouro;
                this.consultant.contract.number = response.numero;
                this.consultant.contract.complement = response.complemento;
                this.consultant.contract.cep = response.cep;
                this.consultant.contract.district = response.bairro;
                this.consultant.contract.city = response.municipio;
                this.consultant.contract.state = response.uf;
            } else {
                return this.errorHandler.interceptError(response, 'Consultor');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Empresa');
        }
    }

    changeSkill(){
         if(this.consultant.skills.length <= this.skillsDropdown.selected.length){
            let diff = _.differenceWith(this.skillsDropdown.selected, this.consultant.skills, (a,b)=> a.id == b._id )
            this.consultant.skills.push({
                _id:diff[0].id,
                name:diff[0].itemName
            })
        }
        else {
            let diff = _.differenceWith(this.consultant.skills,this.skillsDropdown.selected, (a,b)=> a._id == b.id )
            _.remove(this.consultant.skills, item => item._id == diff[0]._id)
        }
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    upload(id) {
        let length = this.selectedFiles.length;
        for(let i=0; i<length; i++){
            const file = this.selectedFiles.item(i);
            this.awsService.uploadfile(file,id);
        }
    }

    addCustomer(index) {
        this.consultant.contract.customers.push({_id: '', name: '', start: null, end: null, managerClient: ''})
        this.projectsDropdown.list.push([]);
        this.projectsDropdown.selected.push('');

    }

    removeCustomer(i) {
        this.consultant.contract.customers.splice(i, 1);
        this.projectsDropdown.list.splice(i, 1);
        this.projectsDropdown.selected.splice(i, 1);
    }

    verifyNameMask(rawValue: string): RegExp[] {
        const mask = /[A-Za-zÁ-Úá-úÀ-Ùà-ùÃ-Õã-õÄ-Üä-üÂ-Ûâ-ûÇç' ']/;
        const strLength = String(rawValue).length;
        const nameMask: RegExp[] = [];
        for (let i = 0; i <= strLength; i++) {
          nameMask.push(mask);
        }
        return nameMask
    }

    verifyDateContractStart(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
            this.consultant[`${doc}`][`end`] = "";
        } else {
            // let dateAux = moment(this.consultant.contract.begin, "DD/MM/YYYY").add(9,'months');
            // this.consultant.contract.end = moment(dateAux).format("DDMMYYYY");
        }
    }
    verifyDate(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
        }
    }
    verifyDate2(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${field}`] = "";
        }
    }

    changeCnae(){
        this.consultant.contract.sapServiceCode = this.cnaes.find(x => x.cnae === this.consultant.contract.cnae).sapItemCode;
    }

    clearSkill() {
        this.skillAux = '';
    }

    async addSkill() {
        try {
            let resp = await this.consultantService.createSkill(this.skillAux.toUpperCase());
            if(resp._id){
                this.skillsDropdown.list = [
                    ...this.skillsDropdown.list,
                    { id: resp._id, itemName: resp.name }
                ]
                this.toastr.success('Skill criada com sucesso');
            } else {
                this.errorHandler.interceptError(resp, 'Consultor');
            }
            this.clearSkill();
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    openAddModalBank(){
        this.bankCode = null
        this.bankName = ""
        this.bankCountry = ""
    }

    async addBank(){
        try {
            const response = await this.bankService.postBank({
                name: this.bankName,
                countryCode: this.bankCountry.toUpperCase(),
                bankCode: this.bankCode
            });

            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco criado com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Banco');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Banco');
        }
    }

    openEditBank(bank:any){
        this.bankForEdit.bankCode = bank.bankCode;
        this.bankForEdit.bankName = bank.name;
        this.bankForEdit.bankCountry = bank.countryCode;
        this.bankForEdit.bankSapCode = bank.sapCode;
    }

    async editBank(){
        try {
            let bankEdit = {
                "active": true,
                "bankCode": this.bankForEdit.bankCode,
                "name": this.bankForEdit.bankName,
                "countryCode": this.bankForEdit.bankCountry.toUpperCase(),
                "sapCode": this.bankForEdit.bankSapCode,
            }

            const response = await await this.bankService.updateBank(bankEdit);
            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco atualizado com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Banco');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Banco');
        }
    }

    openDeleteBank(bank:any){
        this.bankCode = bank.bankCode;
    }

    async removeBank() {
        try {
            const response = await this.bankService.removeBank(this.bankCode);
            if(response.success) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco excluído com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Banco');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Banco');
        }
    }

    onPixTypeChange() {
        this.pixValidation.onPixTypeChange(this.consultant.payment.typePix, this.consultantForm.get("keyPix"))
        this.textMask = {mask: false}
    }

    async verifyPixKey(){
        if (!this.consultant.payment.typePix) {
            return
        }
        this.pixCpfValid = false;
        this.pixCnpjValid = false;

        let typePix = this.consultant.payment.typePix

        switch (typePix) {
            case PixKeyType.phone:
                if(!this.commonHelper.phoneNumberValidator(this.consultant.payment.keyPix)){
                    this.toastr.warning('CPF/CNPJ inválido.');
                    this.consultant.payment.keyPix = "";
                }
                break;
            case PixKeyType.email:
                this.verifyEmailPixKey();
                break;
            case PixKeyType.cpf_cnpj:
                this.verifyCPFCNPJPixKey();
                break;
            case PixKeyType.randomized:
                this.randomPixKeySearch();
                break;
            default:
                break;
        }
    }

    onChangeMask() {
        let typePix = this.consultant.payment.typePix;
        switch (typePix) {
            case PixKeyType.phone:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
                break;
            case PixKeyType.cpf_cnpj:
                let inputValue = this.consultant.payment.keyPix;
                if(!inputValue) return;

                if (inputValue && inputValue.length > 14)
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
                else
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
                break;
            case PixKeyType.randomized:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
                break;
            default:
                break;
        }
    }

    validateKeyPix(control: AbstractControl){
        if(!control.value)
            return {keyPix:true}
        return null;
    }

    disableState() {
        if(this.consultant.personal.country == 'Brasil' ||
           this.consultant.personal.country == '0') {
            this.consultantForm.get('state').enable();
        } else {
            this.consultant.personal.state = '0';
            this.consultantForm.get('state').disable();
        }
    }

    validContract() {
        if(this.user.permission == GUARDS.GOVERNANCE) {
            let valid = this.contractInvalid() || this.consultantPersonalInvalid() ||
            (Number(this.consultant.contract.honorarium) == 1 && !this.consultant.contract.hourValue) ||
            (Number(this.consultant.contract.honorarium) == 2 && !this.consultant.contract.totalValue) ||
            Number(this.consultant.contract.position) == 0

            if(this.consultant.contract.kind === 1)
                if(valid) return false;
                    else return true;
                else
                    return true;
        } else {
            return true;
        }
    }

    contractInvalid() {
        let contractDataInvalid = !this.consultant.contract.cnpj ||
            !this.consultant.contract.companyName ||
            !this.consultant.contract.address ||
            !this.consultant.contract.number ||
            !this.consultant.contract.cep ||
            !this.consultant.contract.city ||
            !this.consultant.contract.state ||
            !this.consultant.contract.begin ||
            this.consultant.contract.state == '0';
        this.contractDataInvalid = contractDataInvalid;
        return contractDataInvalid;
    }

    consultantPersonalInvalid() {
        let personalDataInvalid = !this.consultant.name ||
            !this.consultant.personal.rg ||
            !this.consultant.personal.cpf ||
            !this.consultant.personal.address ||
            !this.consultant.personal.number ||
            !this.consultant.personal.cep ||
            !this.consultant.personal.city ||
            !this.consultant.personal.country ||
            this.consultant.personal.country == '0' ||
            (this.consultant.personal.country == "Brasil" && (!this.consultant.personal.state || this.consultant.personal.state == '0')) ||
            Number(this.consultant.personal.civilStatus) == 0;
        this.personalDataInvalid = personalDataInvalid;
        return personalDataInvalid;
    }

    async changeBorrowNote() {
        if(this.borrowNoteStarted) {
            this.buttonOpenModalBorrowNote.nativeElement.click();
            let consultantsPJ = await this.consultantService.listAll();
            this.consultantsBorrowInvoice = consultantsPJ.filter(c => {
                return c.sapCardCode != '' && c.contract && c.contract.kind == 1 && c.contract.cnpj != '' && c.contract.sapServiceCode != ''
            });
        }
    }

    async getBorrowedNoteData(lenderData: BorrowedNote){
        const receivedData = { ...lenderData };
        if (receivedData.lenderId) {
            this.consultant.borrowInvoiceNote.loadData(receivedData);
        }else {
            this.borrowNoteStarted = false;
            return this.toastr.warning(`Preencha os dados em 'Empréstimo de Nota Fiscal' para prosseguir com
                a geração dos Contrato e Declaração de Nota Emprestada`, 'Nota Emprestada', {TimeOut: 6000});
        };
    };

    async addConsultantProject(projects, consultor) {
        if(projects && projects.length > 0) {
            await projects.map(async project => {
                if(project) {
                    let projectFinancial = await this.projectFinancialService.getByIdConsultantCreate(project);
                    projectFinancial.consultants.push(consultor);

                    let res = await this.projectFinancialService.update(projectFinancial);
                    if(res._id) {
                        this.toastr.success("Projeto atualizado com sucesso");
                    } else {
                        this.errorHandler.interceptError(res, 'Projeto');
                    }
                }
            })
        }
    }

    changeExcellenceCenter() {
        if(this.consultant.excellenceCenter._id)
            this.consultant.excellenceCenter = this.excellenceCenters.find(ec => ec._id == this.consultant.excellenceCenter._id);
    };

    changeSupportCenter() {
        if(this.consultant.supportCenter._id)
            this.consultant.supportCenter = this.supportCenters.find(ec => ec._id == this.consultant.supportCenter._id);
    };

    async changeCustomer(customerID, index) {
        this.projectsAll = await this.projectFinancialService.getProjectsFinancialByCompany(customerID);
        this.projectsDropdown.list[index] = this.dropDownItemFactory.build({source: this.projectsAll});
    }

    setSupportCenterValidator() {
        const mustHaveSupportCenter = '61d332a846958f43022290af'
        if(this.consultant.excellenceCenter && this.consultant.excellenceCenter._id) {
            if (this.consultant.excellenceCenter._id.includes(mustHaveSupportCenter)) {
                this.consultantForm.get('supportCenter').setValidators(Validators.required);
                this.hasRequiredExcellenceCenter = true;
            } else {
                this.hasRequiredExcellenceCenter = false;
                this.consultantForm.get('supportCenter').clearValidators();
            }
        }
        this.consultantForm.get('supportCenter').updateValueAndValidity();
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultant-create/consultant-create.component.ts